import React, {useEffect, useState} from "react";
import {Link as ReactLink} from "react-router-dom";
import {withAuthorization} from '../Session';
import {
    Grid, Hidden,
    Link,
    Paper,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    withStyles, Fab,
} from "@material-ui/core";
import {compose} from "recompose";
import {appStyles} from "../../styles";
import {isMember, isScheduler} from "../../constants";
import {Add} from "@material-ui/icons";
import TripEditor from "../Trips/addTrip";
import {viewDate} from "../Session/utils";

const TripBoard = (props) => {
    const {classes, firebase, authUser} = props;
    const [loading, setLoading] = useState(false);
    const [trips, setTrips] = useState([]);
    const [tripEditorModal, setTripEditorModal] = useState(false);

    useEffect(() => {
        setLoading(true);
        let today = new Date();
        today.setUTCHours(0, 0, 0, 0);

        return firebase.trips()
            .where("xcd.takeoffTime", ">", new Date().toISOString())
            .orderBy(`xcd.takeoffTime`)
            .onSnapshot(snapshot => {
                let trips = [];
                snapshot.forEach(doc => {
                    trips.push({
                        id: doc.id,
                        ...doc.data(),
                    });
                });
                trips.sort((a, b) => {
                    if (new Date(a.xcd.takeoffTime) < new Date(b.xcd.takeoffTime)) return -1;
                    else return 1;
                });
                setTrips(trips);
                setLoading(false);
            });
    }, [authUser.uid, firebase]);

    return (
        <>
        <Paper className={classes.paper}>
            <Hidden xsUp={!isScheduler(authUser)}>
                <Fab className={`${classes.fab} ${classes.fabAdd}`}
                     color="secondary"
                     aria-label="add"
                     size={"small"}
                     onClick={() => {setTripEditorModal(true)}}
                >
                    <Add />
                </Fab>
            </Hidden>
            <h1 className={classes.userContainer}>Trips</h1>
            <TripTable trips={trips} loading={loading} authUser={authUser}/>
        </Paper>
        <TripEditor
            isOpen={tripEditorModal}
            toggle={() => setTripEditorModal(!tripEditorModal)}
        />
        </>
    );
};

export const TripTable = compose(withStyles(appStyles))((props) => {
    const {trips, classes, loading} = props;

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <Grid container>
                            <Grid item xs={4} sm={2}>Location</Grid>
                            <Grid item xs={4} sm={2}>Leave</Grid>
                            <Grid item xs={4} sm={2}>Return</Grid>
                            <Grid item xs={6} sm={2}>Crew</Grid>
                            <Grid item xs={6} sm={2}>RONs</Grid>
                        </Grid>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            <Hidden xsUp={!loading}>
                <TableRow><TableCell><LinearProgress/></TableCell></TableRow>
            </Hidden>
            <Hidden xsUp={loading}>
                    {trips.length > 0 ? trips.map(trip => {
                            return (
                                <React.Fragment key={trip.id}>
                                    <TripRow trip={trip}/>
                                </React.Fragment>
                            );
                        })
                        :
                        <>
                            <Grid container component={TableRow}>
                                <Grid item component={TableCell} xs={12}>None Scheduled</Grid>
                            </Grid>
                        </>
                    }
            </Hidden>
            </TableBody>
        </Table>
    )
});

const TripRow = withAuthorization(isMember)((props) => {
    const {trip} = props;
    return (
        <>
            <TableRow key={trip.id}>
                <TableCell>
                    <Grid container>
                        <Grid item xs={4} sm={2}>
                            <Link component={ReactLink} to={`/trip/${trip.id}`}>{trip.location}</Link>
                        </Grid>
                        <Grid item xs={4} sm={2}>{viewDate(new Date(trip.xcd.takeoffTime), "dd MMM yy")}</Grid>
                        <Grid item xs={4} sm={2}>{viewDate(new Date(trip.xcr.landTime), "dd MMM yy")}</Grid>
                        <Grid item xs={6} sm={2}>{trip.crew ? Object.entries(trip.crew).map(([id, person]) => {
                            return (
                                <React.Fragment key={id}>
                                    {person.username}<br/>
                                </React.Fragment>
                            )
                        }) : "No crew yet"}</Grid>
                        <Grid item xs={6} sm={2}>{Object.entries(trip.rons).map(([id, ron]) => {
                            return (
                                <React.Fragment key={id}>
                            {ron.location}<br/>
                            </React.Fragment>
                            )
                        })}</Grid>
                    </Grid>
                </TableCell>
            </TableRow>
        </>
    );
});

export default compose(
    withStyles(appStyles),
    withAuthorization(isMember),
)(TripBoard);